import './Download.css';
import mobile from '../../../resources/mobile.png'
import apple from '../../../resources/apple.png'

function Download() {
    return (
        <div id='download' className='download_main_div'>
            <div className='all_margin'>
                <div className='margin_auto_width'>
                    <div className='download_inner_main_div'>
                        <div className='download_main_grid_div'>
                            <div>
                                <h1 className='white'>Download <span className='green_gradient_p_animated'>PrepWize</span> Now!</h1>

                                <p className='white_3 font_size_20'>Start your journey to better health by downloading our app. Track your nutrition, and stay on top of your wellness goals—anytime, anywhere.</p>

                                <p className='top_coming_soon_p font_size_18 gray_scale_4'>Available on iOS</p>

                                <div className='download_button_wrapper flex align_center gap_16'>
                                    <a href="https://apps.apple.com/us/app/prepwize-ai-meal-planner/id6744729394" target="_blank" rel="noopener noreferrer" className='mobile_app_button_div'>
                                        <img src={apple} />
                                        <p className='download_store_font_size white'>App Store</p>
                                    </a>
                                </div>
                            </div>

                            <div>
                                <img src={mobile} className='download_moblie_img' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Download;
